import { apiJson } from './http';
import type { StreamFormatOption } from '../lib/streamFormatTransform';

export type BulkReplaceUrlBody = {
  playlist_id: number;
  search: string;
  replace: string;
  target: 'url' | 'logo';
  scope: 'all' | 'selected' | 'categories';
  channel_ids: number[];
  categories: string[];
};

export async function bulkReplaceUrl(body: BulkReplaceUrlBody): Promise<{ success: boolean; message?: string }> {
  return apiJson('/api/channels/bulk_replace_url.php', {
    method: 'POST',
    body: JSON.stringify(body),
  });
}

export type BulkRemoveDuplicatesBody = {
  playlist_id: number;
  key: 'name' | 'url';
  scope: 'all' | 'selected' | 'categories';
  channel_ids: number[];
};

export async function bulkRemoveDuplicates(
  body: BulkRemoveDuplicatesBody,
): Promise<{ success: boolean; message?: string; deleted_count?: number }> {
  return apiJson('/api/channels/bulk_remove_duplicates.php', {
    method: 'POST',
    body: JSON.stringify(body),
  });
}

export type BulkPrefixSuffixBody = {
  playlist_id: number;
  target: 'prefix' | 'suffix';
  text: string;
  remove: boolean;
  scope: 'all' | 'selected' | 'categories';
  channel_ids: number[];
  categories: string[];
};

export async function bulkAddRemovePrefixSuffix(
  body: BulkPrefixSuffixBody,
): Promise<{ success: boolean; message?: string }> {
  return apiJson('/api/channels/bulk_add_remove_prefix_suffix.php', {
    method: 'POST',
    body: JSON.stringify(body),
  });
}

export type BulkStreamFormatBody = {
  playlist_id: number;
  option: StreamFormatOption;
  scope: 'all' | 'selected' | 'categories';
  channel_ids: number[];
  categories: string[];
};

export async function bulkChangeStreamFormat(
  body: BulkStreamFormatBody,
): Promise<{ success: boolean; message?: string }> {
  return apiJson('/api/channels/bulk_change_stream_format.php', {
    method: 'POST',
    body: JSON.stringify(body),
  });
}

export async function bulkMoveChannels(body: {
  from_playlist_id: number;
  to_playlist_id: number;
  channel_ids: number[];
  mode?: 'move' | 'copy';
  target_category?: string;
}): Promise<{
  success: boolean;
  message?: string;
  mode?: string;
  copied?: number;
  moved?: number;
  skipped_duplicate?: number;
  existing_url_count?: number;
  existing_url_channel_names?: string[];
}> {
  return apiJson('/api/channels/bulk_move_playlist.php', {
    method: 'POST',
    body: JSON.stringify(body),
  });
}

